import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useAppId } from '../../context/AppIdContext';
import Header from '../../component/header';

const PracharMasterDashboard = () => {
    const navigate = useNavigate();
    const { language } = useAppId();
    const lang = language || 'en';

    // --- Translation Dictionary (No Subtitles) ---
    const t = {
        en: {
            pageTitle: "Prachar Master",
            subtitle: "Select a promotion method to continue",
            photoPromo: "Photo Promotion",
            videoPromo: "Video Promotion",
            slipPromo: "Slip Promotion",
            printerPromo: "Printer Photo Promo",
            audioPromo: "Audio Promotion",
            textPromo: "Text Promotion",
            selfiePromo: "Selfie Promotion"
        },
        hi: {
            pageTitle: "प्रचार मास्टर",
            subtitle: "जारी रखने के लिए प्रचार विधि चुनें",
            photoPromo: "फोटो प्रचार",
            videoPromo: "वीडियो प्रचार",
            slipPromo: "पर्ची प्रचार",
            printerPromo: "प्रिंटर फोटो प्रचार",
            audioPromo: "ऑडियो प्रचार",
            textPromo: "टेक्स्ट प्रचार",
            selfiePromo: "सेल्फी प्रचार"
        },
        gu: {
            pageTitle: "પ્રચાર માસ્ટર",
            subtitle: "ચાલુ રાખવા માટે પ્રમોશન પદ્ધતિ પસંદ કરો",
            photoPromo: "ફોટો પ્રમોશન",
            videoPromo: "વિડિઓ પ્રમોશન",
            slipPromo: "સ્લિપ પ્રમોશન",
            printerPromo: "પ્રિન્ટર ફોટો પ્રમો",
            audioPromo: "ઑડિઓ પ્રમોશન",
            textPromo: "ટેક્સ્ટ પ્રમોશન",
            selfiePromo: "સેલ્ફી પ્રમોશન"
        }
    };

    const txt = t[lang];

    // --- Premium SVG Icons ---
    const Icons = {
        Photo: () => <svg fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" viewBox="0 0 24 24"><rect x="3" y="3" width="18" height="18" rx="2"/><circle cx="8.5" cy="8.5" r="1.5"/><path d="m21 15-5-5L5 21"/></svg>,
        Video: () => <svg fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" viewBox="0 0 24 24"><polygon points="23 7 16 12 23 17 23 7"/><rect x="1" y="5" width="15" height="14" rx="2"/></svg>,
        Slip: () => <svg fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" viewBox="0 0 24 24"><path d="M4 2v20l2-1 2 1 2-1 2 1 2-1 2 1 2-1 2 1V2l-2 1-2-1-2 1-2-1-2 1-2-1-2 1Z"/><path d="M16 8h-6"/><path d="M16 12h-6"/><path d="M16 16h-6"/></svg>,
        Printer: () => <svg fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" viewBox="0 0 24 24"><polyline points="6 9 6 2 18 2 18 9"/><path d="M6 18H4a2 2 0 0 1-2-2v-5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2h-2"/><rect x="6" y="14" width="12" height="8"/></svg>,
        Audio: () => <svg fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" viewBox="0 0 24 24"><path d="M3 14h3a2 2 0 0 1 2 2v3a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-7a9 9 0 0 1 18 0v7a2 2 0 0 1-2 2h-1a2 2 0 0 1-2-2v-3a2 2 0 0 1 2-2h3"/></svg>,
        Text: () => <svg fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" viewBox="0 0 24 24"><path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"/></svg>,
        Selfie: () => <svg fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" viewBox="0 0 24 24"><path d="M14.5 4h-5L7 7H4a2 2 0 0 0-2 2v9a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V9a2 2 0 0 0-2-2h-3l-2.5-3z"/><circle cx="12" cy="13" r="3"/></svg>
    };

    // --- Options Data Array ---
    const pracharOptions = [
        { id: 1, title: txt.photoPromo, icon: <Icons.Photo />, path: "/photo_promotion", colorClass: "theme-blue" },
        { id: 2, title: txt.videoPromo, icon: <Icons.Video />, path: "/video_promotion", colorClass: "theme-red" },
        { id: 3, title: txt.slipPromo, icon: <Icons.Slip />, path: "/slip_promotion", colorClass: "theme-emerald" },
        { id: 4, title: txt.printerPromo, icon: <Icons.Printer />, path: "/printer_photo_promotion", colorClass: "theme-orange" },
        { id: 5, title: txt.audioPromo, icon: <Icons.Audio />, path: "/audio_promotion", colorClass: "theme-purple" },
        { id: 6, title: txt.textPromo, icon: <Icons.Text />, path: "/text_promotion", colorClass: "theme-amber" },
        { id: 7, title: txt.selfiePromo, icon: <Icons.Selfie />, path: "/selfie_promotion", colorClass: "theme-pink" }
    ];

    const handleNavigate = (path) => {
        navigate(path);
    };

    return (
        <div className='app-container p-4'>

            {/* Header */}
            <Header title={txt.pageTitle} />

            {/* Subtitle */}
            <div className="subtitle-container mt-3 mb-4">
                <p className="subtitle-text">{txt.subtitle}</p>
            </div>

            {/* --- PREMIUM LIST GRID --- */}
            <div className="action-list-grid pb-5">
                {pracharOptions.map((option) => (
                    <div 
                        key={option.id} 
                        className={`action-row ${option.colorClass}`}
                        onClick={() => handleNavigate(option.path)}
                    >
                        <div className="icon-square">
                            {option.icon}
                        </div>
                        
                        <h3 className="row-title">{option.title}</h3>
                    </div>
                ))}
            </div>

            <style jsx>{`
                .app-container {
                    background: #E5E7EB; /* Standard app background */
                    min-height: 100vh;
                    font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif;
                }

                .subtitle-container {
                    margin-bottom: 24px;
                }
                
                .subtitle-text {
                    font-size: 15px;
                    color: #475569;
                    font-weight: 600;
                    margin: 0;
                    text-transform: uppercase;
                    letter-spacing: 0.5px;
                }

                /* --- ACTION ROW GRID --- */
                .action-list-grid {
                    display: grid;
                    /* Adjusted for vertical layout so they form nice squares */
                    grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
                    gap: 20px;
                }

                /* --- ACTION ROW STYLES (NOW VERTICAL & PERMANENTLY STYLED) --- */
                .action-row {
                    background: #ffffff;
                    border-radius: 16px;
                    padding: 40px 20px; /* Increased padding for more height */
                    display: flex;
                    flex-direction: column; /* Stacks items vertically */
                    align-items: center; /* Centers the icon and text */
                    text-align: center;
                    gap: 16px;
                    cursor: pointer;
                    box-shadow: 0 4px 10px rgba(0, 0, 0, 0.04);
                    transition: all 0.25s cubic-bezier(0.4, 0, 0.2, 1);
                    position: relative;
                    min-height: 200px; /* Forces card to be taller */
                }

                .action-row:hover {
                    transform: translateY(-5px);
                    box-shadow: 0 12px 25px -5px rgba(0, 0, 0, 0.1);
                }

                .action-row:active {
                    transform: translateY(0);
                    box-shadow: 0 2px 4px rgba(0,0,0,0.05);
                }

                /* Central Icon Square */
                .icon-square {
                    width: 64px; /* Increased size to look better in center */
                    height: 64px; /* Increased size to look better in center */
                    border-radius: 16px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    flex-shrink: 0;
                    transition: transform 0.3s ease;
                }
                
                .icon-square svg {
                    width: 32px;
                    height: 32px;
                }

                .action-row:hover .icon-square {
                    transform: scale(1.1);
                }

                /* Title below the logo */
                .row-title {
                    font-size: 1.15rem;
                    font-weight: 700;
                    color: #1e293b;
                    margin: 0;
                    white-space: normal;
                }

                /* Right Chevron Circle - Positioned absolutely in the top right */
                .chevron-circle {
                    position: absolute;
                    top: 16px;
                    right: 16px;
                    width: 28px;
                    height: 28px;
                    border-radius: 50%;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    transition: all 0.3s ease;
                }
                
                .chevron-circle svg {
                    width: 14px;
                    height: 14px;
                }

                .action-row:hover .chevron-circle {
                    transform: translateX(3px) translateY(-3px); /* Subtle diagonal movement */
                }

                /* --- COLOR THEMES (PERMANENTLY APPLIED) --- */
                
                /* Blue Theme */
                .theme-blue { border-top: 4px solid #3b82f6; }
                .theme-blue .icon-square { background: #eff6ff; color: #3b82f6; }
                .theme-blue .chevron-circle { background: #3b82f6; color: #ffffff; }

                /* Red Theme */
                .theme-red { border-top: 4px solid #ef4444; }
                .theme-red .icon-square { background: #fef2f2; color: #ef4444; }
                .theme-red .chevron-circle { background: #ef4444; color: #ffffff; }

                /* Emerald Theme */
                .theme-emerald { border-top: 4px solid #10b981; }
                .theme-emerald .icon-square { background: #ecfdf5; color: #10b981; }
                .theme-emerald .chevron-circle { background: #10b981; color: #ffffff; }

                /* Orange Theme */
                .theme-orange { border-top: 4px solid #f97316; }
                .theme-orange .icon-square { background: #fff7ed; color: #f97316; }
                .theme-orange .chevron-circle { background: #f97316; color: #ffffff; }

                /* Purple Theme */
                .theme-purple { border-top: 4px solid #a855f7; }
                .theme-purple .icon-square { background: #faf5ff; color: #a855f7; }
                .theme-purple .chevron-circle { background: #a855f7; color: #ffffff; }

                /* Amber Theme */
                .theme-amber { border-top: 4px solid #f59e0b; }
                .theme-amber .icon-square { background: #fffbeb; color: #f59e0b; }
                .theme-amber .chevron-circle { background: #f59e0b; color: #ffffff; }

                /* Pink Theme */
                .theme-pink { border-top: 4px solid #ec4899; }
                .theme-pink .icon-square { background: #fdf2f8; color: #ec4899; }
                .theme-pink .chevron-circle { background: #ec4899; color: #ffffff; }

                /* Mobile Optimization */
                @media (max-width: 640px) {
                    .action-list-grid { 
                        grid-template-columns: repeat(auto-fill, minmax(150px, 1fr)); 
                        gap: 16px;
                    }
                    .action-row {
                        padding: 30px 16px;
                        min-height: 160px;
                        border-radius: 14px;
                    }
                    .icon-square {
                        width: 54px;
                        height: 54px;
                    }
                    .icon-square svg {
                        width: 26px;
                        height: 26px;
                    }
                    .row-title {
                        font-size: 1.05rem;
                    }
                }
            `}</style>
        </div>
    );
};

export default PracharMasterDashboard;